import { render, staticRenderFns } from "./ModalReferralPartnerEdit.vue?vue&type=template&id=dd667d4a&"
import script from "./ModalReferralPartnerEdit.vue?vue&type=script&lang=js&"
export * from "./ModalReferralPartnerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports